// extracted by mini-css-extract-plugin
export default {"ModalContent":"modal-content_ModalContent__ggi1d"};